<template>
  <a-card :bordered="false" :class="'cust-erp-sub-tab'">
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button v-if="mainSetId" @click="handleAdd" type="primary" icon="plus">新增</a-button>
    </div>

    <!-- table区域-begin -->
    <div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无此图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="图片不存在" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无此文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="uploadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
            <a>删除</a>
          </a-popconfirm>
        </span>

      </a-table>
    </div>

    <busDataSyncDocDetailSet-modal ref="modalForm" @ok="modalFormOk" :mainSetId="mainSetId"></busDataSyncDocDetailSet-modal>
  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import BusDataSyncDocDetailSetModal from './modules/BusDataSyncDocDetailSetModal'



  export default {
    name: "BusDataSyncDocDetailSetList",
    mixins:[JeecgListMixin],
    components: { BusDataSyncDocDetailSetModal },
    props:{
      mainSetId:{
        type:String,
        default:'',
        required:false
      }
    },
    watch:{
      mainSetId:{
        immediate: true,
        handler(val) {
          if(!this.mainSetId){
            this.clearList()
          }else{
            this.queryParam['mainSetId'] = val
            this.loadData(1);
          }
        }
      }
    },
    data () {
      return {
        description: 'bus_data_sync_doc_main_set管理页面',
        disableMixinCreated:true,
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'配置id',
            align:"center",
            dataIndex: 'setId'
          },
          {
            title:'配置名称',
            align:"center",
            dataIndex: 'setName'
          },
          {
            title:'源头业务表',
            align:"center",
            dataIndex: 'dataTable'
          },
          {
            title:'目标业务表',
            align:"center",
            dataIndex: 'targetTable'
          },
          {
            title: '删除数据是否同步',
            align: 'center',
            dataIndex: 'delDataFlag_dictText',
          },
          {
            title:'备注',
            align:"center",
            dataIndex: 'remarks'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' },
          }
        ],
        url: {
          list: "/datadocsync.base/busDataSyncDocMainSet/listBusDataSyncDocDetailSetByMainId",
          delete: "/datadocsync.base/busDataSyncDocMainSet/deleteBusDataSyncDocDetailSet"
        },
        dictOptions:{
         status:[],
        },

      }
    },
    methods: {
      clearList(){
        this.dataSource=[]
        this.ipagination.current = 1
      },

    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>
